import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {push} from 'connected-react-router';

import {getSortedRiderAddresses} from 'ondemand/selectors';
import {deleteRiderAddress, fetchRiderAddressesIfNeeded} from 'ondemand/actions/riderAddress';
import AddressList from 'ondemand/components/AddressList';
import PageLayout from 'ondemand/components/PageLayout';

class AddressesPage extends React.Component {
  static displayName = 'AddressesPage';

  static propTypes = {
    addresses: PropTypes.array,
    addressId: PropTypes.string,
    children: PropTypes.node,
    dispatch: PropTypes.func,
    route: PropTypes.object,
  };

  componentDidMount() {
    this.props.dispatch(fetchRiderAddressesIfNeeded());
  }

  _handleCreate = () => {
    this.props.dispatch(push('/addresses/new'));
  };

  _handleDelete = (addressId) => {
    this.props.dispatch(deleteRiderAddress(addressId));
  };

  _handleEdit = (addressId) => {
    this.props.dispatch(push(`/addresses/edit/${addressId}`));
  };

  render() {
    const {addresses, addressId, children} = this.props;
    if (addresses === null) {
      return null;
    }
    return (
      <PageLayout dataId={'addresses-page-container'} title="My Addresses">
        <AddressList
          addresses={addresses}
          onCreate={this._handleCreate}
          onDelete={this._handleDelete}
          onEdit={this._handleEdit}
          activeId={addressId}
          activeChildren={children}
        />
      </PageLayout>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  addresses: getSortedRiderAddresses(state),
  addressId: ownProps.match.params.addressId,
});

export default connect(mapStateToProps)(AddressesPage);



// WEBPACK FOOTER //
// ./src/ondemand/containers/AddressesPage.js